/* istanbul ignore file */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkyHeaderComponent } from './sky-header/sky-header.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [SkyHeaderComponent],
  exports: [SkyHeaderComponent],
  imports: [CommonModule, RouterModule],
})
export class SharedSkyComponentsModule {}
